var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.327148,
    y: 0.0803223,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#71C6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3271 14.0803C23.3271 19.0509 19.2977 23.0803 14.3271 23.0803M23.3271 14.0803C23.3271 9.10976 19.2977 5.08032 14.3271 5.08032M23.3271 14.0803H5.32715M14.3271 23.0803C9.35659 23.0803 5.32715 19.0509 5.32715 14.0803M14.3271 23.0803C16.5783 20.6158 17.8576 17.4175 17.9271 14.0803C17.8576 10.7432 16.5783 7.54484 14.3271 5.08032M14.3271 23.0803C12.076 20.6158 10.7967 17.4175 10.7271 14.0803C10.7967 10.7432 12.076 7.54484 14.3271 5.08032M5.32715 14.0803C5.32715 9.10976 9.35659 5.08032 14.3271 5.08032",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.34273303ee7a4f479f26afa0c551a509.svg";
export { ForwardRef as ReactComponent };